module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av597-9d1868bf3b77967771213a9ce5bb4c52.jpg";